import {UserReservation} from "../../../../../../../../../server/src/base/entities/leasing/calendar/UserReservation";
import {IUserReservationService} from "../../../../../../domain/leasing/IUserReservationService";
import {ModalTemplate, TemplateModalConfig} from 'ng2-semantic-ui';
import {ICurrentVan} from "../../../../../../domain/leasing/ICurrentVan";
import {CalendarComponent} from "./calendar/calendar";
import {ErrorPopupComponent} from "../../../../generic/popup/errorPopup/errorPopup";
import {ViewChild} from "@angular/core";
import {UserComponent} from "./user/user";
import {Reservation} from "../../../../../../../../../server/src/base/entities/leasing/calendar/Reservation";
import {IVanCalendar} from "../../../../../../domain/leasing/IVanCalendar";
import {PriceComputation} from "../../../../../../infrastructure/leasing/PriceComputation";
import {ReservationInThePastError} from "../../../../../../../../../server/src/base/entities/error/ReservationInThePastError";
import {TakenDateError} from "../../../../../../../../../server/src/base/entities/error/TakenDateError";
import {ServerError} from "../../../../../../../../../server/src/typescript-plugin/error/ServerError";

export interface IContext {
    data:string;
}

declare var $:any;

export abstract class UserReservationEditComponent {
    @ViewChild('modalTemplate') modalTemplate:ModalTemplate<IContext, string, string>;
    @ViewChild(CalendarComponent) calendarComponent:CalendarComponent;
    @ViewChild(UserComponent) userComponent:UserComponent;
    @ViewChild(ErrorPopupComponent) errorPopupComponent:ErrorPopupComponent;

    protected userReservationService:IUserReservationService;
    protected calendar:IVanCalendar;
    protected currentVan:ICurrentVan;
    protected nbVans:number;
    protected config:TemplateModalConfig<IContext, string, string>;
    protected priceComputation:PriceComputation;

    public confirmed:boolean;
    public priceEstimation:number;
    public nbKm:number;

    constructor(userReservationService:IUserReservationService){
        this.userReservationService = userReservationService;
    }

    protected Initialize(){
        this.config = new TemplateModalConfig<IContext, string, string>(this.modalTemplate);
        this.config.closeResult = "closed!";
        this.config.isClosable = false;
        this.config.context = { data: "" };
        this.confirmed = false;
        this.priceEstimation = 0;
        this.nbKm = 300;
    }

    public cancel(modal){
        modal.deny('denied');
        var that = this;
        setTimeout(() => {
            that.confirmed = false;
        }, 500)

    }

    public nextVan(){
        if(this.currentVan.Next()){
            this.UpdateCalendar();
            this.ResetCalendarComponent();
        }
    }

    public previousVan(){
        if(this.currentVan.Previous()){
            this.UpdateCalendar();
            this.ResetCalendarComponent();
        }
    }

    public onKmChaged(value:number){
        this.nbKm = value;
        this.ComputeEstimatedPrice();
    }

    public onSlotSelected(){
        this.ComputeEstimatedPrice();
        this.DisplayPriceBar();
    }

    protected UpdateCalendar(){
        this.calendar.Update(this.currentVan.Value());
    }

    protected FillReservationWithSelectedSlots(userReservation:UserReservation){
        userReservation.reservations = [];
        for(let slot of this.calendarComponent.SelectedSlots()){
            let reservation:Reservation = new Reservation();
            reservation.slot = slot;
            reservation.calendarId = this.currentVan.Value().calendar.id;
            userReservation.reservations.push(reservation);
        }
    }

    protected FillReservationWithUserData(userReservation:UserReservation){
        userReservation.firstname = this.userComponent.Firstname();
        userReservation.lastname = this.userComponent.Lastname();
        userReservation.email = this.userComponent.Email();
        userReservation.phone = this.userComponent.Phone();
        userReservation.comment = this.userComponent.Comment();
    }

    protected HandleServerError(serverError:ServerError){
        if(serverError.Equals(new ReservationInThePastError())){
            this.OpenErrorPopup("Votre réservation contient une journée déjà antérieure à la date actuelle");
        } else if(serverError.Equals(new TakenDateError())){
            this.OpenErrorPopup("Certaines dates sélectionnés ont été reservées par un autre client. " +
                "Veuillez rafraichir la page et choisir une autre date");
        }
    }

    private ComputeEstimatedPrice(){
        this.priceEstimation = this.priceComputation.Compute(this.calendarComponent.SelectedSlots(), this.nbKm);
    }

    protected OpenErrorPopup(message:string){
        this.errorPopupComponent.Open("Impossible de créer la réservation", message);
    }

    protected DisplayPriceBar(){
        setTimeout(() => {
            $('#my-range').range({
                min: (150 * this.priceComputation.NbTotalDays(this.calendarComponent.SelectedSlots())),
                max: 3020,
                start: (150 * this.priceComputation.NbTotalDays(this.calendarComponent.SelectedSlots())),
                onChange: (value) => {this.onKmChaged(value)}
            });
        }, 500)
    }

    protected abstract bookButtonLabel():string;
    protected abstract ResetCalendarComponent();
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/userReservation/userReservationEdit.ts